import i18n from 'i18next';

const SUCCESS = {
  get orderCancel() {
    return i18n.t('success_order_cancelled');
  }
};

export default SUCCESS;
